var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"content_center"},[_vm._v(" กำลังโหลด... ")]),_c('RedirectErrorModal',{ref:"RedirectErrorModal",on:{"Accept":_vm.onRedirect}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }